import { useRef, useEffect } from 'react';

export default value => {
  const previous = useRef();

  useEffect(() => {
    previous.current = value;
  }, [value]);

  return previous.current;
};
